import Background from "../../components/resources/Background.png";

export const main = {
  width: "100vw",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundImage: `url(${Background})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};

export const logo = {
  width: "150px",
  height: "150px",
  margin: "20px 0px",
};

export const link = {
  textDecoration: "none",
};
